import { ColorField } from "./ColorField";
import { Switch } from "../ui/switch";
import { PALETTES } from "../../lib/shield";

const FIELDS = [
  ["primary", "Primary club colour"],
  ["secondary", "Secondary club colour"],
  ["accent", "Accent colour"],
  ["border", "Shield border colour"],
  ["text", "Text colour"],
];

const PaletteButton = ({ p, active, onPick }) => (
  <button type="button" onClick={() => onPick(p)} data-testid={`palette-${p.id}`}
    className={`group flex items-center gap-2 border-2 p-2 text-left transition-colors ${active ? "border-slate-900 bg-lime-50" : "border-slate-200 hover:border-slate-900"}`}>
    <span className="flex h-8 w-10 shrink-0 overflow-hidden border border-slate-300">
      <span className="w-1/2" style={{ background: p.primary }} />
      <span className="w-1/4" style={{ background: p.secondary }} />
      <span className="w-1/4" style={{ background: p.accent }} />
    </span>
    <span className="text-xs font-bold leading-tight">{p.name}</span>
  </button>
);

export const ColoursPanel = ({ colours, onChange, textPanel, onTextPanel }) => {
  const pick = ({ id, name, ...c }) => onChange(c);
  const isActive = (p) => p.primary === colours.primary && p.secondary === colours.secondary;
  return (
    <div className="space-y-5">
      <div>
        <div className="eyebrow mb-2">Quick palettes</div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {PALETTES.map((p) => <PaletteButton key={p.id} p={p} active={isActive(p)} onPick={pick} />)}
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <ColorField key={k} id={k} label={label} value={colours[k]} onChange={(v) => onChange({ ...colours, [k]: v })} />
        ))}
      </div>
      <label className="flex items-center justify-between border-t border-slate-200 pt-4 text-sm font-bold">
        <span>Backing panel behind name &amp; stats<span className="block text-xs font-normal text-slate-500">Keeps text readable on busy or light backgrounds.</span></span>
        <Switch checked={textPanel} onCheckedChange={onTextPanel} data-testid="text-panel-switch" />
      </label>
      <p className="text-xs text-slate-500">Colours apply to built-in backgrounds and decorative details. Uploaded photos and crests keep their original colours.</p>
    </div>
  );
};
